import { render, staticRenderFns } from "./ViewSingleText.vue?vue&type=template&id=397da2f1&scoped=true&"
import script from "./ViewSingleText.vue?vue&type=script&lang=ts&"
export * from "./ViewSingleText.vue?vue&type=script&lang=ts&"
import style0 from "./ViewSingleText.vue?vue&type=style&index=0&id=397da2f1&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397da2f1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
